// Copyright (c) 2022 by Move Closer

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (edited)
 */
export enum Drawers {
  Auth = 'auth'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (edited)
 */
export const drawersRegistry = {
  [Drawers.Auth]: () => import(/* webpackChunkName: "modal/AuthDrawer" */ '../organisms/AuthDrawer/AuthDrawer.vue')
}
